var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor",class:_vm.isMoment?'advEditor':'editor'},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"ready":_vm.onReady,"blur":_vm.onEditorBlur},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }